import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { API_ENDPOINTS } from "../../constant/_constant";
import { toast } from "react-toastify";
import usePostRequest from "../../hooks/usePostRequest";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import useIdleLogout from "../../hooks/useIdleLogout";

function UpdateStatus({ show, onClose }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    watch,
  } = useForm();

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    message: "",
    btntext: "",
    title: "",
  });
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const [bugId, setBugId] = useState("");
  const selectedStatus = watch("status_type");

  const { isLoading: createLoading, postData: createORDER } = usePostRequest(
    API_ENDPOINTS.UPDATE_BUG_PRIORITY
  );

  const onSubmit = async (formData) => {
    try {
      const payload = {
        auto_id: bugId,
        status: formData?.status_type || null,
        ...(selectedStatus === "CLOSED" && {
          closing_comments: formData?.description || null,
        }),
      };

      console.log("✅ Final Payload to submit:", payload);

      createORDER(payload, onSuccess, onError, API_ENDPOINTS.UPDATE_BUG_PRIORITY);
      reset();
      onClose();
      handleClose();
    } catch (err) {
      toast.error("Status update failed.");
    }
  };

  useIdleLogout();

  const onSuccess = (res) => {
    setIsModalOpen({
      show: true,
      title: "Bug Status Updated Successfully!",
      message: `Updated by ${user?.username}. Updated on ${moment(
        new Date()
      ).format("MM/DD/YYYY")}.`,
      btntext: "Return Home",
    });
  };

  useEffect(() => {
    if (window.location.search) {
      const autoId = window.location.search.slice(1);
      setBugId(autoId);
    }
  }, [window.location.search]);

  const handleClose = () => {
    const newUrl = window.location.pathname;
    window.history.replaceState(null, "", newUrl);
    onClose();
  };

  const onError = (error) => {
    toast.error(error?.message);
  };

  return (
    <>
      <SuccsessMsgModal
        show={isModalOpen.show}
        onHide={() =>
          setIsModalOpen(
            { ...isModalOpen, show: false },
          )
        }
        title={isModalOpen.title}
        btntext={isModalOpen.btntext}
        message={isModalOpen.message}
      />
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header className="justify-content-center d-block" closeButton>
          <Modal.Title className="tittle_deal">Update Bug Status</Modal.Title>
        </Modal.Header>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Select Status</Form.Label>
              <InputGroup>
                <Form.Select
                  {...register("status_type", {
                    required: "Order Type is required",
                  })}
                >
                  <option value="">Select a status</option>
                  <option value="OPEN">Open</option>
                  <option value="INPROGRESS">InProgress</option>
                  <option value="RESOLVED">Resolved</option>
                  <option value="CLOSED">Closed</option>
                </Form.Select>
              </InputGroup>
            </Form.Group>
            {selectedStatus === "CLOSED" && (
              <Form.Group className="mb-3">
                <Form.Label className="">Closing Comments</Form.Label>
                <InputGroup>
                  <Form.Control
                    as="textarea"
                    name="Enter description"
                    {...register("description")}
                    style={{
                      height: "auto",
                      minHeight: "90px",
                      resize: "none",
                    }}
                    onInput={(e) => {
                      e.target.style.height = "auto";
                      e.target.style.height = `${e.target.scrollHeight}px`;
                    }}
                    placeholder="Enter comments"
                  />
                </InputGroup>
              </Form.Group>
            )}
          </Modal.Body>

          <Modal.Footer className="justify-content-end">
            <Button variant="warning" type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Submitting..." : "Confirm"}
            </Button>
            <Button variant="outline-secondary" onClick={handleClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default UpdateStatus;
